import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import WelcomePage from "../Components/Onboarding/WelcomePage";

const paths = [
  "welcome-to-stg",
  "onboarding-driver",
  "plan-for-success",
  "message-page"
];

const GetUserId = ({ children }) => {
  const userId = localStorage.getItem("userId");
  const STG_TOKEN = localStorage.getItem("STG_TOKEN");

  if (!userId && !STG_TOKEN) {
    return <Navigate to="/signup" />;
  }

  return children;
};

export default GetUserId;
